import * as actions from '../actions'

const defaultState = null

export default function locales(state = defaultState, action) {
    switch (action.type) {
        case actions.GET_LOCALES:
            if (!action.error) {
                state = action.payload.data
            }
            return state

        case actions.APP_SELECT:
        case actions.CLEAN_ALL:
            return defaultState

        default:
            return state
    }
}
